export var primaryColor = {
  light: "#ffefeb",
  primary: "#ff5837",
  secandary: "#38CB89",
  error: "#ff0000",
};
export var textColor = {
  primary: "#4e5d78",
  secondary: "#535559",
};
export var backgroundColor = {
  primary: "#f5f5f5",
  secondary: "#ffffff", //must be white for all theme
};
export var borderColor = {
  primary: "#cbcbcb",
};

export const setPrimaryColor = (newPrimaryColor) => {
  primaryColor = newPrimaryColor;
};
export const setTextColor = (newTextColor) => {
  textColor = newTextColor;
};
export const setBackgroundColor = (newBackgroundColor) => {
  backgroundColor = newBackgroundColor;
};
export const setBorderColor = (newBorderColor) => {
  borderColor = newBorderColor;
};
